import { User } from '@bioliberty/lifemind';
import { Badge } from '../../components/Badge';
import { getUserStatusBadgeProps } from '../utils';

export function UserStatusCell({ user }: { user: User }) {
  const { label, className } = getUserStatusBadgeProps(user);
  return (
    <Badge variant="outline" className={className}>
      {label}
    </Badge>
  );
}
